import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import { LoginView } from '../../Views/Login/Login.View';
import { InviteView } from '../../Views/Login/Invites/InviteView';
import { LoginLayout } from '../../Views/Login/Layout/Login.Layout';
import { SignUpView } from '../../Views/Login/SignUp/SignUp.View';
import { SelectOrg } from '../../Views/Login/SelectOrg/SelectOrg';
import { AccountInterface } from '@swivl-mono/types';
import AccountModel from '../../Models/Account/AccountModel';
import { ForgotPasswordView } from '../../Views/Login/Forgot/ForgotPassword.View';
import { ResetPasswordView } from '../../Views/Login/Reset/ResetPassword.View';
import TranscriptView from '../../Views/Conversations/Transcript/TranscriptView';



interface Props {
  account?: AccountInterface;
}

export default function RouterLoggedOut(props: Props) {
  const { invites } = AccountModel.useState(s => s);
  if (props.account) {
    if (invites && invites.length > 0) {
      return (
        <Routes>
          <Route path="transcript/:userId" element={<TranscriptView />} />
          <Route path="/" element={<LoginLayout />}>
            <Route path="/invites" element={<InviteView />} />
            <Route path="/invite/:inviteUUID" element={<InviteView />} />
            <Route path="/select-org" element={<SelectOrg />} />
            <Route path="*" element={<Navigate to={'/invites'} />} />
          </Route>
          <Route path="*" element={<Navigate to={'/invites'} />} />
        </Routes>
      );
    }

    return (
      <Routes>
        <Route path="transcript/:userId" element={<TranscriptView />} />
        <Route path="/select-org" element={<LoginLayout />}>
          <Route path="/select-org" element={<SelectOrg />} />
        </Route>
        <Route path="*" element={<Navigate to={'/select-org'} replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="transcript/:userId" element={<TranscriptView />} />
      <Route path="/" element={<LoginLayout />}>
        <Route path="/invite/:inviteUUID" element={<InviteView />} />
        <Route path="/login" element={<LoginView />} />
        <Route path="/forgot-password" element={<ForgotPasswordView />} />
        <Route path="/sign-up" element={<SignUpView />} />
        <Route path="/select-org" element={<SelectOrg />} />
        <Route path="/reset-password/:token" element={<ResetPasswordView />} />
        <Route path="/" element={<Navigate to={'/login'} replace />} />
      </Route>
      <Route path="*" element={<Navigate to={"/login"} replace />} />
    </Routes>
  );
}
